import { TriangleAlert } from 'lucide-react'
import tabStyles from '../../../styles/companyInfoTab.module.css'
import type { CompanyInfoAddressValidationBannerProps } from '../../../types'

export function CompanyInfoAddressValidationBanner({
    message,
    testId = 'company-info-address-warning-banner',
}: CompanyInfoAddressValidationBannerProps) {
    if (!message) return null

    return (
        <div
            className={tabStyles.addressValidationBanner}
            role="alert"
            data-testid={testId}
        >
            <TriangleAlert className={tabStyles.addressValidationBannerIcon} aria-hidden />
            <p className={tabStyles.addressValidationBannerText}>{message}</p>
        </div>
    )
}
